import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    editRegionalProjectRequest: ['response'],
    editRegionalProjectSuccess: ['loading', 'response'],
    editRegionalProjectFailure: ['error'],
})

export const editRegionalProjectTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const editRegionalProjectRequest = state => state.merge({ success: null })

const editRegionalProjectSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const editRegionalProjectFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.EDIT_REGIONAL_PROJECT_REQUEST]: editRegionalProjectRequest,
    [Types.EDIT_REGIONAL_PROJECT_SUCCESS]: editRegionalProjectSuccess,
    [Types.EDIT_REGIONAL_PROJECT_FAILURE]: editRegionalProjectFailure,
})
